// AUTO-GENERATED by Anela.Heblo.AccessMatrixGen. Do not edit by hand.
export interface MenuRequirement { permissions: string[]; }
export const ACCESS_ROUTES: Record<string, MenuRequirement> = {
  "/finance/overview": { permissions: ["finance.financial_overview.read"] },
  "/analytics/product-margin-summary": { permissions: ["finance.margin_analysis.read"] },
  "/automation/invoice-import-statistics": { permissions: ["finance.margin_analysis.read"] },
  "/finance/bank-statements": { permissions: ["finance.margin_analysis.read"] },
  "/finance/price-analysis": { permissions: ["finance.price_analysis.read"] },
  "/products/margins": { permissions: ["products.product_margins.read"] },
  "/catalog": { permissions: ["products.catalog.read"] },
  "/products/pricing": { permissions: ["products.catalog.read"] },
  "/products/statistics": { permissions: ["products.catalog.read"] },
  "/journal": { permissions: ["products.journal.read"] },
  "/customer/issued-invoices": { permissions: ["customer.bank_statements.read"] },
  "/customer/bank-statements-overview": { permissions: ["customer.bank_statements.read"] },
  "/knowledge-base": { permissions: ["customer.knowledge_base.read"] },
  "/customer/smartsupp": { permissions: ["customer.smartsupp.read"] },
  "/purchase/orders": { permissions: ["purchase.purchase_orders.read"] },
  "/purchase/invoice-classification": { permissions: ["purchase.invoice_classification.read"] },
  "/purchase/stock-analysis": { permissions: ["purchase.purchase_stock.read"] },
  "/manufacturing/orders": { permissions: ["manufacture.manufacture_orders.read"] },
  "/manufacturing/batch-planning": { permissions: ["manufacture.batch_planning.read"] },
  "/manufacturing/batch-calculator": { permissions: ["manufacture.batch_planning.read"] },
  "/manufacturing/output": { permissions: ["manufacture.manufacture_output.read"] },
  "/manufacturing/stock-analysis": { permissions: ["manufacture.manufacture_stock.read"] },
  "/manufacturing/inventory": { permissions: ["manufacture.material_inventory.read"] },
  "/manufacturing/product-inventory": { permissions: ["manufacture.product_inventory.read"] },
  "/manufacturing/material-containers": { permissions: ["manufacture.material_containers.read"] },
  "/logistics/inventory": { permissions: ["warehouse.logistics.read"] },
  "/logistics/receive-boxes": { permissions: ["warehouse.logistics.read"] },
  "/logistics/transport-boxes": { permissions: ["warehouse.logistics.read"] },
  "/logistics/packing-materials": { permissions: ["warehouse.logistics.read"] },
  "/logistics/expedition-archive": { permissions: ["warehouse.expedition.read"] },
  "/customer/expedition-settings": { permissions: ["warehouse.expedition.read"] },
  "/baleni": { permissions: ["warehouse.packaging.read"] },
  "/logistics/gift-package-manufacturing": { permissions: ["warehouse.gift_packages.read"] },
  "/stock-up-operations": { permissions: ["warehouse.stock_up.read"] },
  "/articles": { permissions: ["marketing.article.read"] },
  "/marketing/feedback": { permissions: ["marketing.article.write"] },
  "/leaflet-generator": { permissions: ["marketing.leaflet.read"] },
  "/marketing/photobank": { permissions: ["marketing.photobank.read"] },
  "/marketing/calendar": { permissions: ["marketing.marketing_calendar.read"] },
  "/marketing/performance": { permissions: ["marketing.performance.read"] },
  "/marketing/ads/proposals": { permissions: ["marketing.ads.read"] },
  "/marketing/ads/activity": { permissions: ["marketing.ads.read"] },
  "/marketing/ads/settings": { permissions: ["marketing.ad_approvals.admin"] },
  "/automation/meeting-tasks": { permissions: ["anela.meetings.read"] },
  "/automation/mind-maps": { permissions: ["anela.mind_maps.read"] },
  "#org-chart": { permissions: ["anela.org_chart.read"] },
  "/overtime": { permissions: ["attendance.overtime.read"] },
  "/automation/data-quality": { permissions: ["admin.data_quality.read"] },
  "/admin/access": { permissions: ["admin.administration.read"] },
  "/admin/access/groups/:id": { permissions: ["admin.administration.read"] },
  "/admin/access/users/:id": { permissions: ["admin.administration.read"] },
  "/automation/background-tasks": { permissions: ["admin.administration.read"] },
  "/recurring-jobs": { permissions: ["admin.administration.read"] },
  "#hangfire": { permissions: ["admin.administration.read"] },
  "/admin/feature-flags": { permissions: ["admin.feature_flags.read"] },
  "#terminal": { permissions: ["warehouse.logistics.read"] },
  "#baleni-external": { permissions: ["warehouse.packaging.read"] },
};

export const ACCESS_ROLES = [
  "finance.financial_overview.read",
  "finance.margin_analysis.read",
  "finance.price_analysis.read",
  "finance.price_analysis.write",
  "products.product_margins.read",
  "products.catalog.read",
  "products.catalog.write",
  "products.journal.read",
  "products.journal.write",
  "customer.bank_statements.read",
  "customer.knowledge_base.read",
  "customer.knowledge_base.write",
  "customer.smartsupp.read",
  "purchase.purchase_orders.read",
  "purchase.purchase_orders.write",
  "purchase.invoice_classification.read",
  "purchase.invoice_classification.write",
  "purchase.purchase_stock.read",
  "manufacture.manufacture_orders.read",
  "manufacture.manufacture_orders.write",
  "manufacture.batch_planning.read",
  "manufacture.batch_planning.write",
  "manufacture.manufacture_output.read",
  "manufacture.manufacture_stock.read",
  "manufacture.material_inventory.read",
  "manufacture.material_inventory.write",
  "manufacture.product_inventory.read",
  "manufacture.product_inventory.write",
  "manufacture.material_containers.read",
  "manufacture.material_containers.write",
  "manufacture.label_calibration.read",
  "manufacture.label_calibration.write",
  "warehouse.logistics.read",
  "warehouse.logistics.write",
  "warehouse.expedition.read",
  "warehouse.expedition.write",
  "warehouse.packaging.read",
  "warehouse.packaging.write",
  "warehouse.stock_up.read",
  "warehouse.stock_up.write",
  "warehouse.gift_packages.read",
  "warehouse.gift_packages.write",
  "warehouse.stock_override.read",
  "marketing.article.read",
  "marketing.article.write",
  "marketing.leaflet.read",
  "marketing.leaflet.write",
  "marketing.photobank.read",
  "marketing.photobank.write",
  "marketing.photobank.admin",
  "marketing.marketing_calendar.read",
  "marketing.marketing_calendar.write",
  "marketing.performance.read",
  "marketing.performance.write",
  "marketing.ads.read",
  "marketing.ads.write",
  "marketing.ad_approvals.read",
  "marketing.ad_approvals.write",
  "marketing.ad_approvals.admin",
  "marketing.ad_approvals_via_mcp.read",
  "anela.meetings.read",
  "anela.meetings.write",
  "anela.org_chart.read",
  "anela.mind_maps.read",
  "anela.mind_maps.write",
  "anela.process_docs.read",
  "reporting.web_analytics.read",
  "reporting.eshop.read",
  "reporting.accounting.read",
  "attendance.overtime.read",
  "attendance.overtime.write",
  "admin.data_quality.read",
  "admin.data_quality.write",
  "admin.administration.read",
  "admin.administration.write",
  "admin.feature_flags.read",
  "admin.feature_flags.write",
  "jobs.trigger.read",
  "jobs.disable.read",
] as const;
